import React from 'react';
import { PauseTypography } from '../../../PauseTypography';
import { PauseIconButton } from '../../../PauseIconButton';
import { Info } from '../../../../../assets/icons/feather/components';
import { PauseTooltip } from '../../../PauseTooltip';
import { PauseToggle } from '../../../PauseToggle';

type Props = {
  title : string,
  info?: {
    text: string,
    buttonText: string,
    buttonOnClick: () => any,
    buttonHref: string,
  },
  titleHelper?: React.ReactNode | string,
  actions: React.ReactNode,
  hideToggle?: boolean,
  checked?: boolean,
  onToggleChange?: (a: boolean) => any,
  disableToggle: boolean,
  subTitle: any,
}

export const PauseTableTitleWithToggle = ({
  title,
  info,
  titleHelper,
  actions = <></>,
  hideToggle = false,
  checked = false,
  onToggleChange = () => null,
  disableToggle = false,
  subTitle = null,
}: Props) => (
  <div css={(theme) => ({
    // minHeight: theme.spacing(9),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    display: 'grid',
    gridAutoFlow: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    gridGap: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  })}
  >
    <div css={(theme) => ({
      display: 'grid',
      gridAutoFlow: 'column',
      alignItems: 'center',
      gridGap: theme.spacing(0.5),
      justifyContent: 'start',
    })}
    >
      <div>
        <PauseTypography
          variant="subtitle"
          color="pause.primary.medium"
          css={(t) => ({
            display: 'flex',
            gap: t.spacing(1.5),
            alignItems: 'center',
          })}
        >
          {!hideToggle && (
          <div>
            <PauseToggle
              checked={checked}
              onChange={onToggleChange}
              disabled={disableToggle}
            />
          </div>
          )}
          {title}
          {titleHelper ? (
            <>
              <div>
                &bull;
              </div>
              {titleHelper}
            </>
          ) : null}
          {info && info.text && (
          <PauseTooltip
            arrow
            interactive
            buttonText={info.buttonText}
            buttonOnClick={info.buttonOnClick}
            title={info.text}
            buttonHref={info.buttonHref}
          >
            <PauseIconButton
              // @ts-ignore
              icon={<Info />}
              variant="primaryAlt"
              compact
            />
          </PauseTooltip>
          )}
        </PauseTypography>
        {subTitle && (
        <div css={(t) => ({
          marginTop: t.spacing(0.5),
        })}
        >
          {subTitle}
        </div>
        )}
      </div>
    </div>
    {actions && actions}
  </div>

);
